<div [ngClass]="lessonClasses()">
  <div
    [ngClass]="{ 'lesson-top': true, draggable: true }"
    (click)="gotoLesson()"
    [ngStyle]="isDragging ? {'pointer-events': 'none'} : {}"
  >
    <p class="week-number">Week {{ course.displayableLessons.indexOf(lesson) + 1 }}</p>
    <i class="mt-edit" [hidden]="!isRenaming && !isChangingNumSongs"></i>
    <h3 *ngIf="!isRenaming && !isChangingNumSongs">{{ lesson.name }}</h3>
    <input
      *ngIf="isRenaming"
      class="textbox"
      [ngClass]="{ 'margin-edit': isRenaming}"
      [(ngModel)]="lesson.name"
      (ngModelChange)="lessonChanged()"
    />
    <p
      class="description"
      *ngIf="lesson.description && !isDescriptionEdit && !isChangingNumSongs"
    >
      {{ lesson.description }}
    </p>
    <input
      *ngIf="isDescriptionEdit"
      class="description"
      [(ngModel)]="lesson.description"
      (ngModelChange)="lessonChanged()"
    />
    <button
      *ngIf="isChangingNumSongs"
      (click)="chooseNumberOfLessons($event)"
      class="dropdown"
    >
      {{ getLessonNumSongsText() }}
    <i class="mt-arrow-down"></i>
    </button>
  </div>
  <div
    class="lesson-bottom"
    *ngIf="!isRenaming && !isChangingNumSongs && !isDescriptionEdit"
  >
    <button (click)="gotoLesson()"><i class="mt-show"></i></button>
    <button (click)="chooseLessonEdit($event)"><i class="mt-more"></i></button>
  </div>
  <div
    class="lesson-bottom editing"
    *ngIf="isRenaming || isChangingNumSongs || isDescriptionEdit"
  >
    <button class="cancel" (click)="cancel()">Cancel</button>
    <button class="save" (click)="saveLesson()">Save</button>
  </div>
</div>
